import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useSelector, useDispatch } from 'react-redux'
import * as connectedReactRouter from 'connected-react-router'
import * as MODALS from '../../../constants/modals'
import Text from '../Text/Text'
import AuthForm from './AuthForm'
import ExternalLayout from '../Layouts/ExternalLayout'
import FlameSantander from '../Icons/FlameSantander'
import AuthResentModal from './AuthResentModal'
import styles from './auth.module.scss'

const Auth = (props) => {
  const { handleSubmit, handleResent, back, debug } = props

  const dispatch = useDispatch()
  const { slt, error } = useSelector((state) => state.authReducer.content)

  useEffect(() => {
    if (!slt && !debug) dispatch(connectedReactRouter.routerActions.push(back))
  }, [])

  return (
    <ExternalLayout>
      <div className={styles.container}>
        <FlameSantander />

        <Text
          color="gray"
          variation="dark"
          size="lg"
          bold
          inline
          margin="10px 0px"
        >
          Autenticação.
        </Text>
        <Text color="gray" variation="dark" size="md" margin="10px 0px">
          Enviamos por sms o código de 6 dígitos.
          <br />
          Digite abaixo o código para finalizar o cadastro.
        </Text>
      </div>

      <AuthForm handleSubmit={handleSubmit} back={back} error={error} />

      <Text
        inline
        font="custom"
        color="gray"
        variation="dark"
        size="xxs"
        lineHeight="18px"
        margin="24px 0 0"
      >
        Não recebeu seu código?
        <button
          type="button"
          onClick={handleResent}
          style={{ border: 0, background: 'white' }}
        >
          <Text
            bold
            inline
            font="custom"
            color="gray"
            variation="dark"
            size="xxs"
            lineHeight="18px"
            underline
            margin="0 3px"
          >
            Reenviar
          </Text>
        </button>
      </Text>

      <AuthResentModal modalId={MODALS.AUTH_RESENT_MODAL_ID} />
    </ExternalLayout>
  )
}

Auth.defaultProps = {
  handleSubmit: null,
  handleResent: null,
  back: undefined,
  debug: false
}

Auth.propTypes = {
  handleSubmit: PropTypes.func,
  handleResent: PropTypes.func,
  back: PropTypes.string,
  debug: PropTypes.bool
}

export default Auth
